import React, { useState } from "react";
import DialogBox from "../../components/Comman/dialog-box/DialogBox";
import style from "../ai-saas/aiDash.module.css";
import buttonData from "./button.json";
import About from "./About";
import Team from "./Team";
import Career from "./Career";
import { Users, Info, Briefcase, Newspaper } from "lucide-react";
import { motion } from "framer-motion";
import BlogPage from "./Blog/BlogPage";

const AI_SAAS = () => {
  const [activeTab, setActiveTab] = useState(buttonData.buttons[0].name);
  const [showDialog, setShowDialog] = useState(false);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    // console.log("tab", tab)
  };


  const iconMap = {
    Users: <Users size={18} />,
    Newspaper: <Newspaper size={18} />,
    Briefcase: <Briefcase size={18} />
  };

  const handleCloseDialog = (tab) => {
    setShowDialog(false);
    setActiveTab(tab);
  };



  return (
    <>
      <div className={style.container_ai}>
        {buttonData.buttons.map((button, index) => (
          <motion.div
            key={index}
            className={`${style.tab_btn} ${activeTab === button.name ? "" : style.active
              }`}
            onClick={() => handleTabClick(button.name)}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: index * 0.1 }}
          >
            <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              {iconMap[button.icon]}
              {button.name}
            </span>
          </motion.div>
        ))}
      </div>
      <DialogBox
        activeTab={activeTab}
        open={showDialog}
        handleCloseDialog={() => handleCloseDialog(activeTab)}
      />
      {activeTab === "Blog" && (
        <BlogPage />
      )}
      {activeTab === "Team" && (
        <Team
          setActiveTab={setActiveTab}
          activeTab={activeTab}
          setShowDialog={setShowDialog}
          handleCloseDialog={handleCloseDialog}
        />
      )}
      {activeTab === "Career" && (
        <Career
          setActiveTab={setActiveTab}
          activeTab={activeTab}
          setShowDialog={setShowDialog}
          handleCloseDialog={handleCloseDialog}
        />
      )}
    </>
  );
};

export default AI_SAAS;